<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новая база знаний',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новая база знаний',
			items: [],
            knowledge_uuid: '',
            trackBy: 'id',
            
            name: '',
            link: '',
            description: '',

            status: null,
            initStatus: [],
            status_options: [
                { id:'active',   name:'Активна' },
                { id:'update',   name:'Обновление' },
                { id:'indexing', name:'Индексация' },
                { id:'error',    name:'Ошибка' },
            ],
		}
	},

    watch: {
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
    },

	computed: {
        knowledge_item(){
            return this.$store.getters['knowledge/GET_KNOWLEDGE_ITEM'];
        },
        users_list_data(){
            return this.$store.getters['users/GET_USERS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {

        this.knowledge_uuid = this.$route.params.knowledge_uuid ? this.$route.params.knowledge_uuid : '';

        if(this.knowledge_uuid !== ''){

            this.title = 'Редактирование базы знаний';
            document.title = appConfig.title + ' - ' + 'Редактирование базы знаний';

            let data_send = {
                'uuid' : this.knowledge_uuid,
            }

            await this.$store.dispatch('knowledge/FETCH_KNOWLEDGE_ITEM', data_send);

            this.name = this.knowledge_item.name;
            this.link = this.knowledge_item.link;
            this.description = this.knowledge_item.description;

            this.status = this.knowledge_item.status ? this.knowledge_item.status : null;
            this.initStatus = [this.knowledge_item.status];
        }
	},

	methods: {

        async saveTariff(){

            let data_send = {
                'name'        : this.name,
                'link'        : this.link,
                'description' : this.description,
                'status'      : this.status && this.status.id ? this.status.id : null,
            };

            let result = '';

            if(this.knowledge_uuid === ''){
                result = await this.$store.dispatch('knowledge/FETCH_KNOWLEDGE_CREATE', data_send);
            } else {
                data_send.uuid = this.knowledge_uuid;
                result = await this.$store.dispatch('knowledge/FETCH_KNOWLEDGE_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Knowledge'});
            }
        }
	}
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveTariff"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Название базы знаний"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Ссылка на документ"
                                        label-for="link"
                                    >
                                        <b-form-input
                                            id="link"
                                            v-model="link"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Описание"
                                        label-for="description"
                                    >
                                        <b-form-input
                                            id="description"
                                            v-model="description"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
